/* eslint-disable @typescript-eslint/no-require-imports */

import CustomPlatform from "$src/core/utils/platform/platform";

import type * as ExpoCarModule from "./src";

export type {
  CarListItem,
  CarTab,
  CarTabBarTemplate,
  CarSearchRequest,
  CarPlaybackEvent,
  CarPlaybackStatus,
  CarPlayDescriptor,
} from "./src";

// Lazy require(), not a `.native.ts` split: keeps `requireNativeModule("ExpoCar")` from running off iOS.
const impl = CustomPlatform.select<() => typeof ExpoCarModule>({
  ios: () => require("./src") as typeof ExpoCarModule,
  default: () => require("./src/index.stub") as typeof ExpoCarModule,
})();

export const {
  createTemplate,
  setRoot,
  play,
  stopPlayback,
  togglePlayPause,
  seekBy,
  getPlaybackStatus,
  addPlaybackStatusListener,
  showNowPlaying,
  presentAlert,
  setSearchResults,
  isConnected,
  setWindowInterfaceStyle,
  addConnectListener,
  addDisconnectListener,
  addSearchListener,
  addPlaybackEventListener,
  registerCarService,
} = impl;
